// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"480d88c5","703":"08cc447a"}[chunkId] + ".chunk.js";
};